export enum PaymentFrequency {
	Daily = 'daily',
	Weekly = 'weekly',
	Biweekly = 'biweekly',
	Monthly = 'monthly',
	Bimonthly = 'bimonthly',
	Quarterly = 'quarterly',
	Halfyearly = 'halfyearly',
	Yearly = 'yearly',
	Unknown = 'unknown',
}
